export const ProductKeys = {
  id: '_id',
  type: 'type',
  productName: 'name',
  productLogo: 'logo',
  lastUpdateDate: 'last_update_date',
  contacts: 'contacts',
  isPublished: 'published',
  creationDate: 'creation_date',
  searchAliases: 'search_aliases',
  logo: 'logo',
  descriptions: 'descriptions',
  legal: 'legal',
  support: 'support',
  features: 'features',
  faqs: 'faqs',
  linkedResources: 'linked_resources',
  metaKeywords: 'meta_keywords',
  categories: 'categories',
  functionalCategories: 'functional_categories',
  repositories: 'repositories',
  quickStartConfig: 'quick_start_configuration',
  certProjects: 'cert_projects',
  drupalcompanyID: 'drupal_company_id',
  orgID: 'org_id',
  deleted: 'deleted'
};